export default {
  personalProfile: "Fiche personnelle",
  myAccount: "Mon compte",
  back_to_my_account: "Retour sur mon compte",
  already_active: "Votre compte a déjà été activé, veuillez vous connecter",
};
